import { useState } from "react";
import { Link } from "react-router-dom";

const tabs = ["Color", "Cuts", "Treatments", "Extensions", "Bridal"];

const services: Record<string, { name: string; desc: string; price: string; duration: string }[]> = {
  Color: [
    { name: "Signature Balayage", desc: "Hand-painted European sun-kissed dimension.", price: "From $180", duration: "3 hrs" },
    { name: "Full Color", desc: "Rich, even all-over color with shine protection.", price: "From $120", duration: "2 hrs" },
    { name: "Highlights / Lowlights", desc: "Foil or freehand placement for depth and movement.", price: "From $150", duration: "2.5 hrs" },
    { name: "Color Correction", desc: "Expert repair and transformation for compromised color.", price: "Consultation", duration: "4+ hrs" },
  ],
  Cuts: [
    { name: "Precision Cut & Blowout", desc: "Architectural cuts tailored to your face shape.", price: "From $85", duration: "1 hr" },
    { name: "Men's Cut & Style", desc: "Classic European barbering meets modern finish.", price: "From $55", duration: "45 min" },
    { name: "Fringe & Bang Trim", desc: "Quick, precise reshaping between visits.", price: "$25", duration: "15 min" },
    { name: "Textured Layers", desc: "Movement and body added through expert layering.", price: "From $95", duration: "1.5 hrs" },
  ],
  Treatments: [
    { name: "Olaplex Bond Repair", desc: "Restores broken bonds for healthier, stronger hair.", price: "From $60", duration: "1 hr" },
    { name: "Keratin Smoothing", desc: "Frizz-free, glossy results lasting up to 5 months.", price: "From $250", duration: "3 hrs" },
    { name: "Scalp Detox", desc: "Deep cleanse and rebalance for scalp health.", price: "From $80", duration: "1 hr" },
    { name: "Kérastase Fusio-Dose", desc: "Customized in-salon booster treatment.", price: "From $45", duration: "30 min" },
  ],
  Extensions: [
    { name: "Tape-In Extensions", desc: "Seamless, natural-looking volume and length.", price: "From $400", duration: "3 hrs" },
    { name: "Hand-Tied Wefts", desc: "The most natural movement — zero damage method.", price: "From $600", duration: "4 hrs" },
    { name: "Fusion Extensions", desc: "Individual strand bonding for ultimate versatility.", price: "From $700", duration: "5 hrs" },
    { name: "Extension Maintenance", desc: "Move-up, conditioning and reapplication.", price: "From $200", duration: "2 hrs" },
  ],
  Bridal: [
    { name: "Bridal Hair Trial", desc: "Test run before the big day — fully customized.", price: "From $120", duration: "2 hrs" },
    { name: "Wedding Day Styling", desc: "On-location or in-salon bridal looks.", price: "From $200", duration: "2.5 hrs" },
    { name: "Bridal Party Package", desc: "Group bookings for bridesmaids and family.", price: "Custom Quote", duration: "Half Day" },
    { name: "Engagement / Event Updo", desc: "Glamorous formal styling for any occasion.", price: "From $95", duration: "1.5 hrs" },
  ],
};

export default function ServicesSection() {
  const [active, setActive] = useState("Color");
  return (
    <section className="w-full bg-white py-24 px-6" id="services">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-[#C9A96E] text-xs font-semibold tracking-[0.3em] uppercase mb-3 block">What We Do</span>
          <h2 className="text-neutral-900 text-3xl md:text-5xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>Our Services</h2>
          <p className="text-neutral-500 mt-4 text-sm max-w-md mx-auto leading-relaxed">European-trained precision for every hair type, texture, and goal.</p>
        </div>
        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {tabs.map((tab) => (
            <button key={tab} onClick={() => setActive(tab)} className={`px-6 py-2 text-xs font-semibold tracking-widest uppercase rounded-full cursor-pointer transition-all whitespace-nowrap ${active === tab ? "bg-[#C9A96E] text-white" : "bg-[#faf8f5] text-neutral-600 border border-neutral-200 hover:border-[#C9A96E] hover:text-[#C9A96E]"}`}>{tab}</button>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {services[active].map((s) => (
            <div key={s.name} className="bg-[#faf8f5] rounded-lg p-7 border border-neutral-100 hover:border-[#C9A96E] transition-colors group">
              <h3 className="text-neutral-900 font-bold text-base mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>{s.name}</h3>
              <p className="text-neutral-500 text-sm leading-relaxed mb-5">{s.desc}</p>
              <div className="flex items-center justify-between">
                <span className="text-[#C9A96E] font-bold text-sm">{s.price}</span>
                <span className="text-neutral-400 text-xs">{s.duration}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-12">
          <Link to="/booking" className="inline-block bg-[#C9A96E] text-white text-sm font-semibold tracking-widest uppercase px-12 py-4 rounded-sm hover:bg-[#b8934f] transition-colors cursor-pointer whitespace-nowrap">Book a Service</Link>
        </div>
      </div>
    </section>
  );
}
